import React, { Component } from 'react'
import classnames from 'classnames'
import s from './styles.scss'
import { Query, Mutation } from "react-apollo";
import gql from "graphql-tag";
import moment from 'moment'
import Map from '../../../../components/Map'
import { Button } from 'sofia-ui'
import { keyBy } from 'lodash'
import getDistance from '../../../../utils/distance'

const REQUEST_TUTORS_QUERY = `
id
refused_reason
selection_date
refused_date
accepted_date
removed_date
state
answers
tutor {
  id
  _id
  state
  user {
    id
    _id
    first_name
    last_name
  }
}
`

const REQUEST = gql`
query Request($uuid: String) {
  request(_id: $uuid) {
    id
    _id
    location
    tutor {
      id
      _id
    }
    request_students {
      id
      subjects_uuids
      level_uuid
    }
    request_tutors {
      ${REQUEST_TUTORS_QUERY}
    }
  }
}
`

const TUTORS = gql`
query TutorsQuery($search: Search) {
  tutors (search: $search, first: 1000) {
    id
    _id
    state
    location
    lang
    user {
      id
      _id
      first_name
      last_name
      email
      phone_number
    }
    tutor_subject_levels {
      id
      level_uuid
      subject_uuid
      valid
      level {
        id
        _id
        name
      }
      subject {
        id
        _id
        name
      }
    }
  }
}
`

const ADD_TUTOR = gql`
mutation AddTutorToRequesr($input: request_tutorMutation) {
  addRequest_tutor(input: $input) {
    ${REQUEST_TUTORS_QUERY}
  }
}
`

const RESEND_EMAIL = gql`
mutation SendTutorToRequesr($input: request_tutorMutation) {
  sendAddEmailRequest_tutor(input: $input) {
    ${REQUEST_TUTORS_QUERY}
  }
}
`
const UPDATE_STATUS = gql`
mutation UpdateRequestTutor($input: request_tutorMutation) {
  updateRequest_tutor(input: $input) {
    ${REQUEST_TUTORS_QUERY}
  }
}
`

const SELECT_TUTOR = gql`
mutation SelectTutorForRequest($input: request_tutorMutation) {
  selectRequest_tutor(input: $input) {
    ${REQUEST_TUTORS_QUERY}
  }
}
`

class RequestDetails extends Component {

  state = {
    distance: 5,
    state: ['validated', 'completed'],
    isMap: true
  }

  render() {

    if (!this.props.uuid) return null

    const { isMap } = this.state

    return <Query
      query={REQUEST}
      variables={{
        uuid: this.props.uuid
      }}
      >
      {({ loading, error, data, fetchMore }) => {
      if (loading) return null;
      if (error) {
        console.error(error)
        return <p>Error :(</p>
      };

      const location = data.request ? data.request.location : JSON.stringify({ coordinates: [0,0] })
      const selected = data.request ? data.request.request_tutors : []
      const request = data.request ? data.request : {}
      const requestTutor = data.request ? data.request.tutor : { id: 0, _id: "" } 
      console.log('REQUEST', data.request)

      const selectedByUuid = keyBy(selected, 'tutor._id')
      console.log('selected by uuids', selectedByUuid)

      return <Query
        query={TUTORS}
        variables={{
          search: {
            type: 'request',
            data: JSON.stringify({
              location: JSON.parse(location).coordinates,
              distance: this.state.distance,
              state: this.state.state
            })
          }
        }}
        >
        {({ loading, error, data, fetchMore }) => {
        if (loading) return null;
        if (error) {
          console.error(error)
          return <p>Error :(</p>
        };

        const tutors = data.tutors ? data.tutors : []
    
        return <div className={s.container}>

          <div className="box">
            <div className="flex f-space-between">

              <div className="flex f-align-center">
                
                <select className="mr small" value={''+this.state.distance} onChange={e => this.setState({ distance: parseFloat(e.target.value) })}>
                  <option value="1">1 km</option>
                  <option value="1.5">1,5 km</option>
                  <option value="2">2 km</option>
                  <option value="2.5">2.5 km</option>
                  <option value="3">3 km</option>
                  <option value="3.5">3.5 km</option>
                  <option value="4">4 km</option>
                  <option value="5">5 km</option>
                  <option value="7.5">7.5 km</option>
                  <option value="10">10 km</option>
                  <option value="12">12 km</option>
                  <option value="16">16 km</option>
                  <option value="20">20 km</option>
                  <option value="30">30 km</option>
                  <option value="100">100 km</option>
                </select>

                <div>
                  <input
                    type="checkbox" 
                    id="c1"
                    checked={this.state.state.includes('validated')}
                    onChange={e => {
                      if (e.target.checked)
                        this.setState({ state: [...this.state.state, 'validated']})
                      else {
                        const index = this.state.state.findIndex(elm => elm === 'validated')
                        if (index > -1) this.setState({ state: [...this.state.state.slice(0, index), ...this.state.state.slice(index+1)]})
                      }
                    }}
                    />
                  <label htmlFor="c1"><div/> Validated</label>
                </div>

                <div>
                  <input
                    type="checkbox" 
                    id="c2"
                    checked={this.state.state.includes('completed')}
                    onChange={e => {
                      if (e.target.checked)
                        this.setState({ state: [...this.state.state, 'completed']})
                      else {
                        const index = this.state.state.findIndex(elm => elm === 'completed')
                        if (index > -1) this.setState({ state: [...this.state.state.slice(0, index), ...this.state.state.slice(index+1)]})
                      }
                    }}
                    />
                  <label htmlFor="c2"><div/> Completed</label>
                </div>

                <div>
                  <input
                    type="checkbox" 
                    id="c3"
                    checked={this.state.state.includes('in-progress')}
                    onChange={e => {
                      if (e.target.checked)
                        this.setState({ state: [...this.state.state, 'in-progress']})
                      else {
                        const index = this.state.state.findIndex(elm => elm === 'in-progress')
                        if (index > -1) this.setState({ state: [...this.state.state.slice(0, index), ...this.state.state.slice(index+1)]})
                      }
                    }}
                    />
                  <label htmlFor="c3"><div/> In progress</label>
                </div>

              </div>

              <div>

                <i className={classnames('fas', 'fa-map', s.tab, isMap && s.active)} onClick={() => this.setState({ isMap: true })}></i>
                <i className={classnames('fas', 'fa-bars', s.tab, !isMap && s.active)}  onClick={() => this.setState({ isMap: false })}></i>
              </div>
            
            </div>

            
          </div>

          {isMap && <div className={s.map}>
            <Map
              center={JSON.parse(location).coordinates}
              basePoint={JSON.parse(location)}
              points={tutors.map(({ location, ...rest }) => ({
                geometry: JSON.parse(location),
                details: {
                  ...rest,
                  state: selectedByUuid[rest._id] ? 'selected': rest.state
                }
              }) )}
              hasDetails
            />
          </div>}

          {!isMap && <div className={classnames('flex', 'f-wrap', 'f-stretch', s.list)}>
            {tutors.map(({ id, _id, state, user, tutor_subject_levels, lang, ...tutor }) => !selectedByUuid[_id] ? <div className={classnames('box', s.listBox)}>
              <b>{user.first_name} {user.last_name}</b> <br/>
              <small><i>{state}</i> • {lang} •  <b>{tutor.location ? (getDistance(JSON.parse(tutor.location).coordinates, JSON.parse(location).coordinates)).toFixed(2) : "0"} km</b></small>
              <div className="flex f-align-center f-wrap">
                {tutor_subject_levels.map(({ level, subject, valid }) => <div className={classnames('tag', 'small', !valid && s.invalid)}>
                  {subject.name} • <i>{level.name}</i>
                </div>)}
              </div>
              <br />
              <a href={`/users/tutor/${user._id}`} target="_blank">
                <Button small inline color="dark">Voir le profil</Button>
              </a>

              {!requestTutor && <Mutation mutation={ADD_TUTOR}
                update={(cache, { data: { addRequest_tutor } }) => {
                  const { request } = cache.readQuery({ query: REQUEST, variables: { uuid: this.props.uuid } });
                  console.log('NEW REQUEST', request, addRequest_tutor)
                  cache.writeQuery({
                    query: REQUEST,
                    data: { request: {
                      ...request,
                      request_tutors: [...request.request_tutors, addRequest_tutor]
                    }}
                  });
                }}
              >
                {(add, { data }) => (
                    <Button small color='green' onClick={e => add({ variables: { input: { 
                      "request_id": request.id,
                      "request_uuid": request._id,
                      "selection_date": moment().toISOString(),
                      "tutor_id": id,
                      "tutor_uuid": _id,
                      "state": "SENT"
                    } } })}>Ajouter</Button>
                )}
              </Mutation>}

            </div> : null)}
          </div>}

          <br />

          <h2>Tuteurs sélectionnés</h2>

          <div className={classnames('flex', 'f-wrap', 'f-stretch', s.list)}>
            {selected.map(({ id, answers, tutor: { user }, tutor, state }) => <div className={classnames('box', s.listBox)}>
              <b>{user.first_name} {user.last_name}</b> <br />
              <small><i>{tutor.state}</i> {tutor.location ? getDistance(JSON.parse(tutor.location).coordinates, JSON.parse(location).coordinates) : null}</small>
              <br />
              <label>State</label>
              <Mutation mutation={UPDATE_STATUS}>
                {(update, { data }) => (
                    <select value={state} onChange={e => update({ variables: { input: { 
                      id,
                      state: e.target.value
                    } } })}>
                      <option value="SENT">Envoyée</option>
                      <option value="INTERESTED">Intéressé</option>
                      <option value="APRROVED">Approuvé</option>
                      <option value="REFUSED">Refusée</option>
                    </select>
                )}
              </Mutation>
              <br />
              {answers && <div>
                <br />
                {JSON.stringify(answers, null, 2).split('\n').map((item, key) => {
                  return <React.Fragment key={key}>{item}<br/></React.Fragment>
                })}
              </div>}
              <br />
              <a href={`/users/tutor/${user._id}`} target="_blank">
                <Button small inline color="dark">Voir le profil</Button>
              </a>
              {!requestTutor && <span>
                <Mutation mutation={RESEND_EMAIL}>
                  {(resend, { data }) => (
                      <Button small color='green' inline onClick={e => resend({ variables: { input: { 
                        id,
                        "request_id": request.id,
                        "request_uuid": request._id,
                        "tutor_id": tutor.id,
                        "tutor_uuid": tutor._id
                      } } })}>Renvoyer SMS et courriel</Button>
                  )}
                </Mutation>
                <Mutation mutation={SELECT_TUTOR}>
                  {(select, { data }) => (
                      <Button small color='red' onClick={e => select({ variables: { input: {
                        id, 
                        "request_id": request.id,
                        "request_uuid": request._id,
                        "tutor_id": tutor.id,
                        "tutor_uuid": tutor._id,
                        answers,
                        state: 'APRROVED'
                      } } })}>Choisir</Button>
                  )}
                </Mutation>
              </span>}
            </div>)}
          </div>

        </div>

      }}
      </Query>

      }}
  </Query>
  }
}

export default RequestDetails;



// WEBPACK FOOTER //
// ./src/containers/requests/Details/tabs/tutors.js